// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"380306ec","125":"2e101ffb","157":"d60f3497","252":"cba8fad5","266":"d5c910c8","513":"c04d9b58","553":"fcd472b0","703":"9c72e022","719":"bdef274c","776":"ad975413","787":"87bd09dc","789":"ad9493a8"}[chunkId] + ".chunk.js";
};